import React from 'react';
import { useHistory } from 'react-router-dom';
import withShipment from '../../withShipment';
import { userInfoSelector } from '../../redux/selectors/auth';
import { authLogout } from '../../redux/actions/auth';
import Icon from '../ui/Icon';
import './screens.css';

function MoreScreen({ userInfo, authLogout }) {
  const history = useHistory();
  const routes = userInfo?.routes ? [...userInfo.routes] : [];
  const has = (id) => routes.includes(id);

  const name = [userInfo?.firstname, userInfo?.lastname].filter(Boolean).join(' ') || userInfo?.username;

  // User + app management now lives in App Control (master-admin). Folder
  // management is inside the Document Center app. So only App Control remains
  // here as an admin entry.
  const manageItems = [
    has('app-control') && { icon: 'ShieldCheck', label: 'App Control', to: '/admin/app-control' },
  ].filter(Boolean);

  return (
    <div className="hive-container hive-screen">
      <h1 className="hive-h2 hive-screen-h">More</h1>

      <div className="hive-more-card">
        <div className="hive-more-avatar">{(name || 'B').charAt(0).toUpperCase()}</div>
        <div>
          <div className="hive-more-name">{name}</div>
          <div className="hive-more-email">{userInfo?.username}</div>
        </div>
      </div>

      {manageItems.length > 0 && (
        <MoreGroup title="Manage">
          {manageItems.map((it) => (
            <MoreRow key={it.to} icon={it.icon} label={it.label} onClick={() => history.push(it.to)} />
          ))}
        </MoreGroup>
      )}

      <MoreGroup title="General">
        <MoreRow icon="Boxes" label="Workspaces" onClick={() => history.push('/workspaces')} />
        <MoreRow icon="Layers" label="My Apps" onClick={() => history.push('/my-apps')} />
        <MoreRow icon="Store" label="Browse the Store" onClick={() => history.push('/store')} />
        <MoreRow icon="Info" label="About BeeNexa Hive" onClick={() => history.push('/')} />
      </MoreGroup>

      <MoreGroup>
        <MoreRow icon="LogOut" label="Log out" danger onClick={authLogout} />
      </MoreGroup>

      <p className="hive-more-version">BeeNexa Hive · One account, unlimited apps</p>
    </div>
  );
}

function MoreGroup({ title, children }) {
  return (
    <section className="hive-more-group">
      {title && <div className="hive-more-grouptitle">{title}</div>}
      <div className="hive-more-list">{children}</div>
    </section>
  );
}

function MoreRow({ icon, label, onClick, danger }) {
  return (
    <button type="button" className={`hive-more-row hive-tap${danger ? ' hive-more-danger' : ''}`} onClick={onClick}>
      <Icon name={icon} size={19} />
      <span className="hive-more-label">{label}</span>
      <Icon name="ChevronRight" size={18} className="hive-more-chevron" />
    </button>
  );
}

export default withShipment(
  {
    mapStateToProps: (state) => ({ userInfo: userInfoSelector(state) }),
    actionCreators: { authLogout },
  },
  MoreScreen
);
